<div class="d-flex flex-row row-cols-2 gap-2 fs-9 fw-semibold">
  @if (config!.type == 'data') {
  <div [class]="`col-12 ${!config.data? 'select-with-spinner': ''}`">
    <span class="col-12"
      >{{ config.label.key | translate }}:<strong class="text-tertiary">{{
        config.required ? "*" : ""
      }}</strong></span
    >
    <select [class]="`form-select fs-9 `" [formControl]="selectBoxControl">
      <option value="" disabled selected hidden>
        {{ config!.placeholder.key | translate }}
      </option>
      @if(config.data){ 
        <!-- @if(config.data.length <= 0){
      <option value="" disabled>
        {{ 'klk' | translate }}
      </option>
        } -->
        @for (data of config!.data; track
      data[config.keys.value]) {
      <option [value]="data[config.keys.value]">
        {{ getOptionLabel(data) }}
      </option>
      } }
    </select>
    @if (!config.data) {
    <div class="custom-icon">
      <icon [icon]="spinnerIcon" [color]="'primary'" />
    </div>
    }
  </div>
  } @if (config!.type == 'base') {
  <div [class]="`col-12`">
    <span class="col-12"
      >{{ config.label.key | translate }}:<strong class="text-tertiary">{{
        config.required ? "*" : ""
      }}</strong></span
    >
    <select class="form-select fs-9" [formControl]="selectBoxControl">
      <option value="" disabled selected hidden>
        {{ config!.placeholder.key | translate }}
      </option>
      @for (option of config!.options; track option.key) {
      <option [value]="option.value">
        {{ option.label.key | translate }}
      </option>
      }
    </select>
  </div>
  }
</div>
<!-- select-with-spinner -->
